module.exports = __webpack_public_path__ + "static/media/Merck.5a483105.png";